import Vue from 'vue'

import VueToastr from '@deveodk/vue-toastr'
import '@deveodk/vue-toastr/dist/@deveodk/vue-toastr.css'
Vue.use(VueToastr, {
  defaultPosition: 'toast-top-center',  
  defaultTimeout: 3000,
  closeButton: true  
})


export function msg_erro(msg) {
    // toastr.options = {
    //     "closeButton": true,
    //     "debug": false,
    //     "progressBar": true,
    //     "preventDuplicates": true,
    //     "positionClass": "toast-top-full-width",
    //     "onclick": null,
    //     "showDuration": "400",
    //     "hideDuration": "1000",
    //     "timeOut": "7000",
    //     "extendedTimeOut": "1000",
    //     "showEasing": "swing",
    //     "hideEasing": "linear",
    //     "showMethod": "fadeIn",
    //     "hideMethod": "fadeOut"
    //   }

    this.$toastr.warning(msg, '');
}


export function msg_sucesso(msg) {
    
    // toastr.options = {
    //     "closeButton": true,
    //     "debug": false,
    //     "progressBar": true,
    //     "preventDuplicates": true,
    //     "positionClass": "toast-top-full-width",
    //     "onclick": null,
    //     "showDuration": "400",
    //     "hideDuration": "1000",
    //     "timeOut": "7000",
    //     "extendedTimeOut": "1000",
    //     "showEasing": "swing",
    //     "hideEasing": "linear",
    //     "showMethod": "fadeIn",
    //     "hideMethod": "fadeOut"
    //   }

    this.$options.parent.$toastr.success(msg, '');
    // this.$toastr.success(msg, '');

}